/**
 * Brewie ROAS Helpers
 * - UTM preservation across internal pages
 * - Meta Pixel event helpers
 * - Conversion triggers for funnel sections
 */

(function () {
  'use strict';

  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  function getQueryParams() {
    const params = new URLSearchParams(window.location.search);
    const out = {};
    UTM_KEYS.forEach((key) => {
      if (params.has(key)) out[key] = params.get(key);
    });
    return out;
  }

  function storeUtms() {
    const utms = getQueryParams();
    if (Object.keys(utms).length) {
      try {
        sessionStorage.setItem('brewie_utms', JSON.stringify(utms));
      } catch (e) {}
    }
  }

  function getStoredUtms() {
    try {
      return JSON.parse(sessionStorage.getItem('brewie_utms') || '{}');
    } catch (e) {
      return {};
    }
  }

  function appendUtmsToLinks() {
    const utms = getStoredUtms();
    if (!Object.keys(utms).length) return;

    document.querySelectorAll('a[href^="/"], a[href^="' + window.location.origin + '"]').forEach((link) => {
      if (link.href.includes('#') || link.href.includes('?')) return;
      const url = new URL(link.href);
      Object.entries(utms).forEach(([key, value]) => {
        url.searchParams.set(key, value);
      });
      link.href = url.toString();
    });
  }

  function trackEvent(name, params) {
    if (window.fbq) fbq('track', name, params || {});
  }

  function initEmailCaptureTracking() {
    document.querySelectorAll('[data-email-capture-form] form').forEach((form) => {
      form.addEventListener('submit', () => {
        trackEvent('Lead');
      });
    });
  }

  function initAddToCartTracking() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-bump-atc], [data-add-to-cart], form[action*="/cart/add"] button[type="submit"]');
      if (btn) trackEvent('AddToCart');
    });
  }

  function initCheckoutTracking() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('a[href*="/checkout"], button[name="checkout"]');
      if (btn) trackEvent('InitiateCheckout');
    });
  }

  storeUtms();
  appendUtmsToLinks();
  initEmailCaptureTracking();
  initAddToCartTracking();
  initCheckoutTracking();

  window.BREWIE = window.BREWIE || {};
  window.BREWIE.track = trackEvent;
  window.BREWIE.utms = getStoredUtms;
})();
